import React from 'react';
import { useMobile } from '../../../../hooks/useMobile';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogHeader from './DialogHeader';
import DialogContent from './DialogContent';
import DialogActions from './DialogActions';
import DialogTextBelowActions from './DialogTextBelowActions';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme: any) => ({
  root: {
    textAlign: 'center',
    '& .MuiDialog-paper': {
      overflowY: 'inherit',
      backgroundColor: theme.palette.brand.white,
      padding: theme.spacing(4),
      paddingLeft: theme.spacing(7),
      paddingRight: theme.spacing(7),
      maxWidth: ({ maxWidth }: { maxWidth: number }) => maxWidth,
    },
    '& .MuiBackdrop-root': {
      backgroundColor: '#000',
      opacity: '0.3 !important',
    },
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(0.5),
    left: theme.spacing(0.5),
    color: 'black',
  },
  logo: { width: 70, alignSelf: 'center' },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...(props as any)} />;
});

export default function CustomDialog({
  open,
  title,
  subtitle = null,
  content,
  img = null,
  actions = null,
  textBelowActions = null,
  showCancelButton = false,
  onClose = null,
  maxWidth = 500,
  ...rest
}) {
  const mobile = useMobile('sm');
  const classes = useStyles({ maxWidth });
  if (mobile) {
    rest['TransitionComponent'] = Transition;
  }

  return (
    <Dialog
      open={open}
      className={classes.root}
      onClose={onClose}
      disableRestoreFocus
      fullScreen={mobile}
      {...rest}
    >
      {img && (
        <img src={`./icons/${img}.svg`} className={classes.logo} alt={img} />
      )}
      {showCancelButton && onClose && (
        <IconButton onClick={onClose} className={classes.closeButton}>
          <CloseIcon />
        </IconButton>
      )}
      <DialogHeader title={title} subtitle={subtitle} />
      <DialogContent>{content}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
      {textBelowActions && (
        <DialogTextBelowActions>{textBelowActions}</DialogTextBelowActions>
      )}
    </Dialog>
  );
}
